import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class FormAction extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'form-action';
    }
    getDirectiveType() {
        return DirectiveType.Navigation;
    }
    getMinimumCspVersion() {
        return 2;
    }
}
